export const LOAD_ORDERS = 'LOAD_ORDERS'
export const LOAD_ORDERS_STATUS = 'LOAD_ORDERS_STATUS'

